import { AbstractControl } from '@angular/forms';

export default function cannotContainNumbers(control: AbstractControl) {
  if (control && control.value) {
    const value = control.value;
    if (/[0-9]/.test(value)) {
      return {
        cannotContainNumbers: true,
      };
    }
  }
  return null;
}
